
import NewsMarquee from "@/components/NewsMarquee/index.vue";
import UnitTextField from "./UnitTextField.vue";

export default {
	name: 'HeroPage',
	components: { NewsMarquee, UnitTextField },
	data () {
		return {
			SWAP_ICON:
			`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="24" viewBox="0 0 512 512">
				<g transform="scale(1, -1) translate(0, -450)">
					<path data-glyph="swap-vertical" fill="currentColor" d="M192 384l-85 -85h64v-150h42v150h64zM341 85v150h-42v-150h-64l85 -85l85 85h-64z"/>
				</g>
			</svg>`,
			baseURL: process.env.NUXT_APP_PANEL_BASE_URL,
			convert: {
				fromCoins: [],
				toCoins: [],
				fromCoinModel: { unit: '', amount: '' },
				toCoinModel: { unit: '', amount: '' },
				setTarget: '',
				setAmount: '',
				config: {},
				blockWatch: false,
			},
			newsContent: {
				increase: {
					emojis: ['🚀', '🔥', '📈', '💰', '🤑', '💎', '🌕', '🪙', '🎉', '✅'],
					texts: [
						'{ICON} {COIN} climbed {ARROW} {CHANGE}, reaching {PRICE}',
						'{ICON} {COIN} rose {ARROW} {CHANGE} and is now trading at {PRICE}',
						'{ICON} {COIN} gained {ARROW} {CHANGE}, moving up to {PRICE}',
						'{ICON} {COIN} advanced {ARROW} {CHANGE} to settle at {PRICE}',
						'{ICON} {COIN} appreciated {ARROW} {CHANGE}, pushing its price to {PRICE}',
						'{ICON} {COIN} increased by {ARROW} {CHANGE}, hitting {PRICE}',
						'{ICON} {COIN} surged {ARROW} {CHANGE} to {PRICE}',
						'{ICON} {COIN} edged up {ARROW} {CHANGE}, standing at {PRICE}',
						'{ICON} {COIN} jumped {ARROW} {CHANGE} and is valued at {PRICE}',
					],
				},
				decrease: {
					emojis: ['📉', '🔻', '😬', '💔', '🥀', '🧯', '⚠️', '🪦', '😢', '⛔'],
					texts: [
						'{ICON} {COIN} slipped {ARROW} {CHANGE}, dropping to {PRICE}',
						'{ICON} {COIN} declined {ARROW} {CHANGE} and is now at {PRICE}',
						'{ICON} {COIN} dipped {ARROW} {CHANGE} to {PRICE}',
						'{ICON} {COIN} fell {ARROW} {CHANGE}, sliding down to {PRICE}',
						'{ICON} {COIN} decreased {ARROW} {CHANGE}, moving lower to {PRICE}',
						'{ICON} {COIN} lost {ARROW} {CHANGE} and trades at {PRICE}',
						'{ICON} {COIN} dropped {ARROW} {CHANGE}, now standing at {PRICE}',
						'{ICON} {COIN} weakened {ARROW} {CHANGE}, reaching {PRICE}',
						'{ICON} {COIN} sank {ARROW} {CHANGE} to {PRICE}',
					],
				},
				stable: {
					emojis: ['⚖️', '🚥', '😐'],
					texts: [
						'{ICON} {COIN} remained unchanged at {PRICE}',
						'{ICON} {COIN} held flat at {PRICE}',
					],
				},
			},
			newsFeed: [],
		};
	},
	computed: {
		isLogin ()
		{
			return (typeof window !== 'undefined' && !!window.localStorage.getItem('Enifex.AccessToken'));
		},
		getStartedLink ()
		{
			if(this.isLogin) return this.baseURL + '/exchange';
			return this.baseURL + '/register';
		},
		fakeButtons ()
		{
			return [
				{ icon: require('@/assets/icons/hero-trade.svg'),   title: 'Spot Trade',   desc: 'Trade cryptocurrencies instantly' },
				{ icon: require('@/assets/icons/hero-demo.svg'),    title: 'Demo Trading', desc: 'Practice trading risk-free'       },
				{ icon: require('@/assets/icons/hero-staking.svg'), title: 'Staking',      desc: 'Earn rewards on your holdings'    },
				{ icon: require('@/assets/icons/hero-bots.svg'),    title: 'AI Guru Bot',  desc: 'AI-powered trading insights'      },
			];
		},
		convertButtonLink ()
		{
			if(this.isLogin){
				const url = new URL(this.baseURL + '/convert');
				if(this.convert.fromCoinModel){
					const amount = (/^\d+(?:\.\d+)?$/.test(this.convert.fromCoinModel.amount) ? Number(this.convert.fromCoinModel.amount) : 0);
					url.searchParams.append('from', amount + '_' + this.convert.fromCoinModel.unit);
				}
				if(this.convert.toCoinModel){
					const amount = (/^\d+(?:\.\d+)?$/.test(this.convert.toCoinModel.amount) ? Number(this.convert.toCoinModel.amount) : 0);
					url.searchParams.append('to', amount + '_' + this.convert.toCoinModel.unit);
				}
				return String(url);
			}else{
				return this.baseURL + '/register';
			}
		},
	},
	watch: {
		'convert.fromCoinModel.unit': function (v) { this.loadConvertTargetCoins(v); },
		'convert.toCoinModel.unit': function (v) { this.loadConvertConfig(this.convert.fromCoinModel.unit, v); },
		'convert.fromCoinModel.amount': function (v) {
			if(!this.convert.blockWatch){
				this.convert.blockWatch = true;
				if(this.convert.config.exchangeRate && /^\d+(?:\.\d+)?$/.test(v)){
					this.convert.toCoinModel.amount = Number((Number(v) * this.convert.config.exchangeRate).toFixed(8)) + '';
				}else{
					this.convert.toCoinModel.amount = '0';
				}
				this.$nextTick(() => { this.convert.blockWatch = false; });
			}
		},
		'convert.toCoinModel.amount': function (v) {
			if(!this.convert.blockWatch){
				this.convert.blockWatch = true;
				if(this.convert.config.exchangeRate && /^\d+(?:\.\d+)?$/.test(v)){
					this.convert.fromCoinModel.amount = Number((Number(v) * (1 / this.convert.config.exchangeRate)).toFixed(8)) + '';
				}else{
					this.convert.fromCoinModel.amount = '0';
				}
				this.$nextTick(() => { this.convert.blockWatch = false; });
			}
		},
	},
	methods: {
		adjustSize ()
		{
			if(this.$refs.section){
				this.$nextTick(() => {
					const sectionRect = this.$refs.section.getBoundingClientRect();
					const docScrollTop = document.documentElement.scrollTop;
					const h = window.innerHeight - (sectionRect.top + docScrollTop);
					this.$refs.section.style.minHeight = Math.max(h, 480) + 'px';
				});
			}
		},
		scrollToAppSection ()
		{
			const sec = document.querySelector('#app-section');
			if(sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
		},
		getRandomEmoji (change)
		{
			if(change > 0){
				const emojis = this.newsContent.increase.emojis;
				return emojis[Math.floor(Math.random() * emojis.length)];
			}
			if(change < 0){
				const emojis = this.newsContent.decrease.emojis;
				return emojis[Math.floor(Math.random() * emojis.length)];
			}
			const emojis = this.newsContent.stable.emojis;
			return emojis[Math.floor(Math.random() * emojis.length)];
		},
		getRandomText (change)
		{
			if(change > 0){
				const texts = this.newsContent.increase.texts;
				return texts[Math.floor(Math.random() * texts.length)];
			}
			if(change < 0){
				const texts = this.newsContent.decrease.texts;
				return texts[Math.floor(Math.random() * texts.length)];
			}
			const texts = this.newsContent.stable.texts;
			return texts[Math.floor(Math.random() * texts.length)];
		},
		breakSymbol (symbol, base)
		{
			symbol = String(symbol).trim().toUpperCase();
			if(symbol.indexOf('/') > 0){
				const parts = symbol.split(/\//);
				return { coin: parts[0], base: parts[1] };
			}
			return { coin: symbol, base: base || 'USDT' };
		},
		getCoinLogo (symbol)
		{
			symbol = this.breakSymbol(symbol);
			return `https://cdn.enifex.com/${symbol.coin}.svg`;
		},
		async loadNewsFeed ()
		{
			try{
				const symbolsData = await this.$store.dispatch('markets/fetchMarketsPricesList');
				if(symbolsData.length > 0){
					this.newsFeed = symbolsData.filter((item) => item.symbol.endsWith('/USDT')).map((item) => ({
						coin: item.displayName,
						icon: this.getCoinLogo(item.symbol),
						text: this.getRandomText(item.chg),
						change: item.chg * 100,
						price: item.lastDayClose,
					}));
				}
			}catch(err){
				console.error(err.message);
			}
		},
		async loadConvertSourceCoins ()
		{
			try{
				const response = await this.$store.dispatch('markets/fetchSupportedSourceCoins');
				if(response.code == 200){
					const coinsList = response.data.map(coin => ({
						value: coin.coinDataDto.unit,
						text: coin.coinDataDto.unit,
						disp: coin.coinDataDto.displayName,
						usdt: coin.usdtRate,
					}));
					this.convert.fromCoins = coinsList;
					if(coinsList.length > 0){
						const unit = this.convert.fromCoinModel.unit || 'BTC';
						this.convert.fromCoinModel.unit = (coinsList.findIndex(c => (c.value == unit)) >= 0 ? unit : coinsList[0].value);
					}
				}
			}catch(err){
				console.error(err.message);
			}
		},
		async loadConvertTargetCoins (sourceCoin)
		{
			if(!sourceCoin){
				this.convert.toCoins = [];
				this.convert.toCoinModel = { unit: '', amount: '' };
			}else{
				try{
					const response = await this.$store.dispatch('markets/fetchSupportedTargetCoins', sourceCoin);
					if(response.code == 200){
						const coinsList = response.data.map(coin => ({
							value: coin.coinDataDto.unit,
							text: coin.coinDataDto.unit,
							disp: coin.coinDataDto.displayName,
							usdt: coin.usdtRate,
						}));
						this.convert.toCoins = coinsList;
						if(coinsList.length > 0){
							let unit = 'USDT';
							if(this.convert.setTarget){ unit = this.convert.setTarget; this.convert.setTarget = ''; }
							this.convert.toCoinModel.unit = (coinsList.findIndex(c => (c.value == unit)) >= 0 ? unit : coinsList[0].value);
						}
					}
				}catch(err){
					console.error(err.message);
				}
			}
		},
		async loadConvertConfig (sourceCoin, targetCoin)
		{
			if(sourceCoin && targetCoin){
				try{
					const response = await this.$store.dispatch('markets/fetchConvertConfig', { source: sourceCoin, target: targetCoin });
					if(response.code == 200){
						this.convert.config = response.data;
						this.$nextTick(() => {
							if(this.convert.setAmount){
								this.convert.fromCoinModel.amount = this.convert.setAmount;
								this.convert.setAmount = '';
							}else if(!this.convert.fromCoinModel.amount){
								this.convert.fromCoinModel.amount = '1';
							}
						});
					}
				}catch(err){
					console.error(err.message);
				}
			}
		},
		swapConvertCoins ()
		{
			if(this.convert.fromCoinModel.unit && this.convert.toCoinModel.unit){
				this.convert.setTarget = this.convert.fromCoinModel.unit;
				this.convert.setAmount = this.convert.toCoinModel.amount;
				this.convert.fromCoinModel.unit = this.convert.toCoinModel.unit;
			}
		},
	},
	created ()
	{
		this.loadNewsFeed();
		this.loadConvertSourceCoins();
	},
	mounted ()
	{
		if(window) window.addEventListener('resize', this.adjustSize);
		this.$nextTick(() => { this.$nextTick(() => { this.adjustSize(); }); });
	},
	beforeDestroy ()
	{
		if(window) window.removeEventListener('resize', this.adjustSize);
	},
}
